import Http from './http'

const Trans = function(msgs = []) {
	var self = this;

	this.msgs = msgs;
	return {
		get: function(value, params, ashtml = false) {
			const idx = value.indexOf('_');
			const prop = value.substring(0, idx);
			const name = value.substring(idx + 1);

			// se ficheiro da mensagem nao carregado, carrega-o
			if (!self.msgs.hasOwnProperty(prop)) {
				http.get('/translations/get.json?file=' + prop, {
						async: false,
						dataType: 'json'
					},
					response => self.msgs[prop] = response.hasOwnProperty('strings') ? response['strings'] : []
				)
			}
			const file = self.msgs[prop]
			let msg = file.hasOwnProperty(name)
				? file[name]
				: (file.hasOwnProperty(value) ? file[value] : name);

			if (params) {
				msg = msg.replace(/\{(\w+)\}/g, function(j, k) {
					return params && params.hasOwnProperty(k) ? params[k] : j; // inserir parametros
				});
			}
			return !ashtml ? msg : <span dangerouslySetInnerHTML={{__html: msg}} />;
		},

		getif: function(str, params) {
			if (str.startsWith('@')) {
				return trans.get(str.substring(1), params);
			}
			return str;
		},

		set: function(files) {
			if (files.name) {
				self.msgs[files.name] = files.hasOwnProperty('strings') ? files['strings'] : [];
			}
			else {
				files = files.strings || files;
				for (var i in files) {
					self.msgs[i] = files[i];
				}
			}
		},

		load: function(files, callback) {
			if (!Array.isArray(files)) {
				files = typeof files === 'string' || files instanceof String ? [files] : [];
			}
			// verificar se alguns dos ficheiros solicitados para carregar, já foi carregado
			for (var i = files.length - 1; i >= 0; i --) {
				if (self.msgs.hasOwnProperty(files[i])) {
					files.pop();
				}
			}
			if (files.length == 0) {
				if (callback instanceof Function) {
					callback();
				}
				return;
			}
			$.ajax('/translations/get.json', {
				dataType: 'json',
				data: {file: files},
				success: response => trans.set(response)
			}).done(() => {
				if (callback instanceof Function) {
					callback();
				}
			});
		}
	}
}
window.trans = new Trans(hp.store.trans);
window.__ = (value, params, ashtml) => window.trans.get(value, params, ashtml)

delete hp.store.trans;

export default Trans;
